export default __webpack_public_path__ + "static/media/lap_image7.74e79f74.webp";